import { useTranslation } from 'react-i18next'
import { type CurrencyCode } from '@/services/graphql/generated'
import { Text } from 'ui/src/components/Text/Text'
import { sprinkles } from 'ui/src/theme/sprinkles.css'
import { DetailsList } from '../DetailsList/DetailsList'
import { Price } from '../Price'

type Props = {
  label?: string
  currencyCode: CurrencyCode
  amount: number
  reducedAmount?: number
  labelNote?: string
  note?: string
  showPlusIcon?: boolean
}

export function TotalPrice({ label, currencyCode, amount, reducedAmount, labelNote, note, showPlusIcon }: Props) {
  const { t } = useTranslation('cart')

  return (
    <DetailsList.Root size="md">
      <DetailsList.Item className={sprinkles({ color: 'textPrimary' })}>
        <DetailsList.Label>
          {label ?? t('CHECKOUT_PRICE_TOTAL')}
          {labelNote ? (
            <Text size="sm" color="textSecondary">
              {labelNote}
            </Text>
          ) : null}
        </DetailsList.Label>
        <DetailsList.Value>
          <Price
            className={sprinkles({ justifyContent: 'flex-end' })}
            currencyCode={currencyCode}
            amount={amount}
            reducedAmount={reducedAmount}
            showPlusIcon={showPlusIcon}
          />
          {note ? (
            <Text size="sm" color="textSecondary">
              {note}
            </Text>
          ) : null}
        </DetailsList.Value>
      </DetailsList.Item>
    </DetailsList.Root>
  )
}
